import { useEffect } from "react";
import { useRouter } from "next/router";

export default function useScrollToHash({
  mobileOffset = 80,
  desktopOffset = 100,
} = {}) {
  const router = useRouter();

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (!router.asPath.includes("#")) return;

    const id = router.asPath.split("#")[1];
    if (!id) return;

    let attempts = 0;

    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        const isMobile = window.innerWidth < 640;
        const offset = isMobile ? mobileOffset : desktopOffset;
        const y = el.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: y, behavior: "smooth" });
      } else if (attempts < 10) {
        attempts++;
        setTimeout(tryScroll, 100);
      }
    };

    tryScroll();
  }, [router.asPath, mobileOffset, desktopOffset]);
}
